import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Button, ButtonGroup, Checkbox, FormControlLabel, FormGroup, Grid, TextField, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getUserFullName } from 'app/utils/appHelpers';
import { ASSET_IMAGES } from 'app/utils/constants/paths';
import config from 'config';
import dayjs from 'dayjs';
import 'dayjs/locale/tr';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTemplateFontSettings } from 'styles/templateFontSettings';


function WatchingMeetingDataTableFilter({ onApplyFilters, onClearFilters }) {

  const [state, setState] = useState({
    startedDate: null,
    finishedDate: null,
    checkedInst: {
      AKM: false,
      TDK: false,
      ATAM: false,
      TTK: false,
      YK: false,
      other: false,
      list: []
    },
  });

  const [dataUnit, setDataUnit] = useState([]);
  const [selectedDataUnits, setSelectedDataUnits] = useState([]);
  const [selectedUserList, setSelectedUserList] = useState([]);
  const { startedDate, finishedDate } = state;

  const { data: userList } = useSelector(state => state.user);
  const users = Array.isArray(userList) ? userList : [];
  const allAuthorizedUnits = useSelector(state => state.auth.allAuthorizedUnits) || [];
  const allAuthorizedInsts = useSelector(state => state.auth.allAuthorizedInsts) || [];

  useEffect(() => {
    const selectedInsts = config.insts.filter((inst) => state.checkedInst[inst]);
    if (selectedInsts.length === 0) {
      setDataUnit(allAuthorizedUnits);
      return;
    }
    setDataUnit(allAuthorizedUnits.filter((unit) => selectedInsts.includes(unit.inst)));
    setSelectedDataUnits((prev) =>
      prev.filter((unit) => selectedInsts.includes(unit.inst))
    );
  }, [allAuthorizedUnits, state.checkedInst]);

  const buildFilters = () => {
    const insts = config.insts.filter((inst) => state.checkedInst[inst]);
    return {
      insts: insts.length ? insts : undefined,
      unitIds: selectedDataUnits.map((unit) => unit.id),
      adminUserIds: selectedUserList.map((user) => user.id),
      dateFrom: startedDate ? dayjs(startedDate).format('YYYY-MM-DD') : undefined,
      dateTo: finishedDate ? dayjs(finishedDate).format('YYYY-MM-DD') : undefined,
    };
  };

  const clearFilter = () => {
    setSelectedUserList([]);
    setSelectedDataUnits([]);
    setState({
      startedDate: null,
      finishedDate: null,
      checkedInst: {
        AKM: false,
        TDK: false,
        ATAM: false,
        TTK: false,
        YK: false,
        other: false,
        list: []
      }
    });
    if (onClearFilters) onClearFilters();
  };

  const applyFilter = () => {
    if (onApplyFilters) onApplyFilters(buildFilters());
  };

  const handleChangeCheckedInst = (name) => event => {
    const newCheckedInst = { ...state.checkedInst, [name]: event.target.checked };
    setState({
      ...state,
      checkedInst: newCheckedInst,
    })
  }



  const { baseFontSize } = useTemplateFontSettings()

  return (

    <Accordion

      sx={{
        background: '#e1e1e1',
        fontSize: baseFontSize,
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"

        sx={{
          minHeight: '30px',
          '& .MuiAccordionSummary-content': {
            margin: '4px 0',
          },
        }}

      >
        <Typography>
          Filtreler


        </Typography>
      </AccordionSummary>


      <AccordionDetails

        sx={{
          fontSize: '14px',
          '& *': {
            fontSize: 'inherit'
          }
        }}
      >

        <Grid container item xs={12} sm={12} lg={12}

          sx={{ background: '#e1e1e1', fontSize: baseFontSize }}

        >

          <Grid item xs={12} sm={4} lg={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"tr"}>

              <DatePicker
                label="Başlangıç"
                value={startedDate}
                onChange={(newValue) => {
                  setState({ ...state, startedDate: newValue });
                }}
                renderInput={(params) => <TextField size="small" sx={{ m: 1 }}  {...params} />}
              />

              <DatePicker
                label="Bitiş"
                className='m-1'
                value={finishedDate}
                onChange={(newValue) => {
                  setState({ ...state, finishedDate: newValue });
                }}
                renderInput={(params) => <TextField size="small" sx={{ m: 1 }} {...params} />}
              />

            </LocalizationProvider>
          </Grid>


          {allAuthorizedUnits ? (
            <Grid item xs={12} sm={4} lg={2}>

              <Grid item xs={12} sm={12} lg={12} padding={1}>

                <Autocomplete
                  multiple
                  id="autocomplete"
                  options={dataUnit}
                  size='small'
                  getOptionLabel={(option) => option.name}
                  value={selectedDataUnits}
                  onChange={(event, newValue) => {
                    setSelectedDataUnits(newValue);

                  }}
                  componentsProps={{
                    popper: {
                      sx: {
                        '& .MuiAutocomplete-listbox': {
                          fontSize: baseFontSize, // Açılır menüdeki seçeneklerin font boyutu
                        },
                      },
                    },
                  }}

                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Kurul/Kol/Komisyon"
                      placeholder="Kurul/Kol/Komisyon seçiniz"
                    />
                  )}
                />

              </Grid>

              <Grid item xs={12} sm={12} lg={12} padding={1}>
                <Autocomplete
                  multiple
                  size='small'
                  id="autocomplete"
                  options={users}
                  getOptionLabel={(option) => getUserFullName(option)}
                  value={selectedUserList}
                  onChange={(event, newValue) => {
                    setSelectedUserList(newValue);

                  }}
                  componentsProps={{
                    popper: {
                      sx: {
                        '& .MuiAutocomplete-listbox': {
                          fontSize: baseFontSize, // Açılır menüdeki seçeneklerin font boyutu
                        },
                      },
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Kullanıcı"
                      placeholder="Kullanıcı Seçiniz"
                    />
                  )}
                />
              </Grid>

            </Grid>

          ) : null}



          <Grid item xs={12} sm={3} lg={3} sx={{ alignSelf: 'center', textAlign: 'center' }}>

            <FormGroup row >

              {allAuthorizedInsts.includes("YK") && (
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={state.checkedInst.YK}
                      onChange={handleChangeCheckedInst('YK')}
                      value="YK"
                    />
                  }
                  label={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src={`${ASSET_IMAGES}/logos/YK.png`}
                        width="30px"
                        alt="Yönetim Kurulu"
                        title="Yönetim Kurulu"
                      />
                      <span style={{ marginLeft: '8px' }}>YK</span>
                    </div>
                  }
                />
              )}

              {allAuthorizedInsts.includes("ATAM") && (
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={state.checkedInst.ATAM}
                      onChange={handleChangeCheckedInst('ATAM')}
                      value="ATAM"
                    />
                  }
                  label={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src={`${ASSET_IMAGES}/logos/ATAM.png`}
                        width="30px"
                        alt="Atatürk Araştırma Merkezi"
                        title="Atatürk Araştırma Merkezi"
                      />
                      <span style={{ marginLeft: '8px' }}>ATAM</span>
                    </div>
                  }
                />
              )}

              {allAuthorizedInsts.includes("AKM") && (
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={state.checkedInst.AKM}
                      onChange={handleChangeCheckedInst('AKM')}
                      value="AKM"
                    />
                  }
                  label={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src={`${ASSET_IMAGES}/logos/AKM.png`}
                        width="30px"
                        alt="Atatürk Kültür Merkezi"
                        title="Atatürk Kültür Merkezi"
                      />
                      <span style={{ marginLeft: '8px' }}>AKM</span>
                    </div>
                  }
                />
              )}

              {allAuthorizedInsts.includes("TDK") && (
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={state.checkedInst.TDK}
                      onChange={handleChangeCheckedInst('TDK')}
                      value="TDK"
                    />
                  }
                  label={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src={`${ASSET_IMAGES}/logos/TDK.png`}
                        width="30px"
                        alt="Türk Dil Kurumu"
                        title="Türk Dil Kurumu"
                      />
                      <span style={{ marginLeft: '8px' }}>TDK</span>
                    </div>
                  }
                />
              )}

              {allAuthorizedInsts.includes("TTK") && (
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={state.checkedInst.TTK}
                      onChange={handleChangeCheckedInst('TTK')}
                      value="TTK"
                    />
                  }
                  label={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src={`${ASSET_IMAGES}/logos/TTK.png`}
                        width="30px"
                        alt="Türk Tarih Kurumu"
                        title="Türk Tarih Kurumu"
                      />
                      <span style={{ marginLeft: '8px' }}>TTK</span>
                    </div>
                  }
                />
              )}

            </FormGroup>

          </Grid>








          <Grid item xs={12} sm={6} lg={1}>
            <ButtonGroup sx={{ marginTop: 3 }} size='small'>
              <Button onClick={() => applyFilter()}>Uygula</Button>
              <Button onClick={() => clearFilter()}>Temizle</Button>
            </ButtonGroup>
          </Grid>


        </Grid>

      </AccordionDetails >




    </Accordion >



  )
}





export default WatchingMeetingDataTableFilter